var Widget          = require("./Widget");

var Button = Widget.extend({

    /**
     *
     * @param options
     */
    initialize: function(options) {
        var that = this,
            eventType;

        options || (options = {});

        Button.__super__.initialize.call(that, options);

        that._container.addClass('omjs-button');

        if (typeof options.events == 'object') {
            for (eventType in options.events) {
                that.on(eventType, options.events[eventType]);
            }
        }
    },

    /**
     *
     * @param eventType
     * @param handler
     * @return {Button}
     */
    on: function(eventType, handler){
        var that = this;

        if (that._container[0].addEventListener) {
            that._container[0].addEventListener(eventType, handler, false);
        }
        else if (that._container[0].attachEvent) {
            that._container[0].attachEvent("on" + eventType, handler);
        }

        return that;
    }
});

module.exports = Button;


//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/Button.js
// module id = 199
// module chunks = 0